import { formatShortDate } from '@cartwheel/string-utils'
import { StatCell } from './stat-cell'
import { SummaryCardDivider } from './summary-card-divider'
import { SummaryCardShell } from './summary-card-shell'

interface Props {
  lastAppointmentDate: string | null
  upcomingAppointmentDate: string | null
}

const DATE_VALUE_CLASS = 'text-[24px] text-charcoal-75'

export function LastUpcomingCard({ lastAppointmentDate, upcomingAppointmentDate }: Props) {
  return (
    <SummaryCardShell className="items-stretch gap-4">
      <StatCell
        label="Last Appt"
        value={formatShortDate(lastAppointmentDate)}
        valueClassName={DATE_VALUE_CLASS}
      />
      <SummaryCardDivider />
      <StatCell
        label="Upcoming Appt"
        value={formatShortDate(upcomingAppointmentDate)}
        valueClassName={DATE_VALUE_CLASS}
      />
    </SummaryCardShell>
  )
}
